import { Pipe, PipeTransform } from '@angular/core';
import { ProductStylingViewModel } from '../../../models/shared/product-styling-view-model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'isLowAmountCannabinoidOrTAC',
  standalone: true
})
export class IsLowAmountCannabinoidOrTACPipe implements PipeTransform {
  transform(
    productStylingViewModel: ProductStylingViewModel,
    cannabinoid: string,
    notApplicable: boolean = false
  ): Observable<boolean> {
    return notApplicable
      ? of(false)
      : productStylingViewModel.rowViewModel$.pipe(
          map(sectionRowViewModel => sectionRowViewModel?.getCannabinoid(cannabinoid)?.indexOf('<') > -1)
        );
  }
}
